export const ENUM__component_type = {
  /*
   * GENERATION
   */

  // general use
  PAGE_GENERATION_BUTTON_BAR_USE_AS_GRID2D_COLUMN: 'PAGE_GENERATION_BUTTON_BAR_USE_AS_GRID2D_COLUMN',
  PAGE_GENERATION_BUTTON_BAR_USE_AS_GRID2D_ROW: 'PAGE_GENERATION_BUTTON_BAR_USE_AS_GRID2D_ROW',

  PAGE_GENERATION_BUTTON_GENERATION_START: 'page_generation_button_generation_start',
  PAGE_GENERATION_BUTTON_GENERATION_START_ALL_NOT_FINISHED: 'page_generation_button_generation_start_all_not_finished',
  PAGE_GENERATION_BUTTON_GENERATION_CONTINUE: 'page_generation_button_generation_continue',
  PAGE_GENERATION_BUTTON_GENERATION_COMMIT: 'page_generation_button_generation_commit',
  PAGE_GENERATION_BUTTON_GENERATION_START_WITH_NEW_SEEDS: 'page_generation_button_generation_start_with_new_seeds',
  PAGE_GENERATION_BUTTON_GENERATION_STOP: 'page_generation_button_generation_stop',
  PAGE_GENERATION_BUTTON_LIST_ITEM_CHANGE_VISIBILITY: 'page_generation_button_listitem_change_visibility',

  // IMAGE CANVAS VIEW
  PAGE_GENERATION_BUTTON_GENERATION_SETTINGS_IMAGE_CANVAS: 'page_generation_button_generation_settings_image_canvas',
  PAGE_GENERATION_IMAGE_CANVAS_VIEW_BLOCK: 'page_generation_image_canvas_view_block',

  // PROMPT VIEW
  PAGE_GENERATION_BUTTON_RANDOMIZE_TOKENS_WEIGHTS: 'page_generation_button_randomize_tokens_weights',
  PAGE_GENERATION_BUTTON_DELETE_ALL_TOKENS: 'page_generation_button_delete_all_tokens',
  PAGE_GENERATION_TOKEN_WEIGHT: 'page_generation_token_weight',
  PAGE_GENERATION_TOKEN_BAR: 'page_generation_token_bar',

  /*
   * LORA
   */
  G_SLIDER_LORA: 'G_SLIDER_LORA',

  /*
   * IP ADAPTER
   */
  G_SLIDER__IP_ADAPTER: 'G_SLIDER__IP_ADAPTER',
  G_SLIDER_RANGE__IP_ADAPTER_SCALE_MASTER: 'G_SLIDER_RANGE__IP_ADAPTER_SCALE_MASTER',
  G_SLIDER_RANGE__IP_ADAPTER_IMAGE_WEIGHT: 'G_SLIDER_RANGE__IP_ADAPTER_IMAGE_WEIGHT',

  /*
   * GUIDANCE SCALE
   */
  G_SLIDER_RANGE__GUIDANCE_SCALE: 'G_SLIDER_RANGE__GUIDANCE_SCALE',
  G_SLIDER__GUIDANCE_SCALE: 'G_SLIDER__GUIDANCE_SCALE',

  G_VIEW__GUIDANCE_SCALE: 'G_VIEW__GUIDANCE_SCALE',

  /*
   * CLIP SKIP
   */

  G_SLIDER__CLIP_SKIP: 'G_SLIDER__CLIP_SKIP',
  G_SLIDER_RANGE__CLIP_SKIP: 'G_SLIDER_RANGE__CLIP_SKIP',

  /*
   * LORA
   */
  G_SLIDER__LORA_WEIGHT_MASTER: 'G_SLIDER__LORA_WEIGHT_MASTER',
  G_SLIDER_RANGE__LORA_WEIGHT_MASTER: 'G_SLIDER_RANGE__LORA_WEIGHT_MASTER',

  G_SLIDER_RANGE__LORA_WEIGHT: 'G_SLIDER_RANGE__LORA_WEIGHT',

  /*
   *
   */

  // DIFFUSION MODEL VIEW
  PAGE_GENERATION_BUTTON_DIFFUSION_MODEL_DROPDOWN_TRIGGER: 'page_generation_button_diffusion_model_dropdown_trigger',

  // IMAGE SIZE VIEW
  PAGE_GENERATION_BUTTON_IMAGE_SIZE_ASPECT_RATIO_DROPDOWN_TRIGGER: 'page_generation_button_image_size_aspect_ratio_dropdown_trigger',
  PAGE_GENERATION_BUTTON_IMAGE_SIZE_MULTIPLIER: 'page_generation_button_image_size_multiplier',

  // SEED VIEW
  PAGE_GENERATION_SEED_VIEW_BLOCK: 'page_generation_seed_view_block',
  PAGE_GENERATION_SEED_BAR: 'page_generation_seed_bar',

  // SAMPLING METHOD VIEW
  PAGE_GENERATION_SAMPLING_METHOD_VIEW_BLOCK: 'page_generation_sampling_method_view_block',

  // SAMPLING STEPS VIEW
  PAGE_GENERATION_INFERENCE_STEPS_VIEW_BLOCK: 'page_generation_inference_steps_view_block',

  /*
   * SEARCH
   */
  PAGE_SEARCH_TOKEN_BAR: 'page_search_token_bar',

  PAGE_SEARCH_SCOPE_DROPDOWN_TRIGGER: 'page_search_scope_dropdown_trigger',
  PAGE_SEARCH_ORIENTATION_DROPDOWN_TRIGGER: 'page_search_orientation_dropdown_trigger',
  PAGE_SEARCH_DIFFUSION_MODEL_DROPDOWN_TRIGGER: 'page_search_diffusion_model_dropdown_trigger',
  PAGE_SEARCH_HISTORY_LIST_ITEM: 'page_search_history_list_item',
  PAGE_SEARCH_HISTORY_LIST_ITEM_TITLE: 'page_search_history_list_item_title',

  /*
   * COLLECTION
   */
  PAGE_COLLECTION_ITEM_LIST: 'page_collection_item_list',
  PAGE_COLLECTION_ITEM_LIST_TITLE: 'page_collection_item_list_title',

  /*
   * USER TASKS
   */
  PAGE_USER_TASKS_LIST_ITEM: 'page_user_tasks_list_item',
  PAGE_USER_TASKS_LIST_ITEM_TITLE: 'page_user_tasks_list_item_title',
};
